// src/services/authService.js
// import axios from "axios";

import axios from "axios";
import { BACKEND_URL } from "../config/config";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USER,
  USERID,
  USERNAME,
} from "../config/constants";

// const API_URL = "http://localhost:3007/api"; // Ajusta la URL según tu backend

// const login = (nombre, password) => {
//   return axios.post(`${API_URL}/login`, { nombre, password });
// };

// export default login;
export class Auth {
  baseApi = BACKEND_URL;

  async register(data) {
    try {
      const url = `${this.baseApi}/signup`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async login(nombre, password) {
    try {
      return axios.post(`${BACKEND_URL}/login`, { nombre, password });
    } catch (error) {
      // notification.error({
      //   message: "Error",
      //   description: "Error al procesar la solicitud",
      // });
      console.log("catch login err", error);
    }
  }

  async refreshAccessToken(refreshToken) {
    try {
      const url = `${this.baseApi}/refreshToken`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: refreshToken,
        }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  setAccessToken(token) {
    localStorage.setItem(ACCESS_TOKEN, token);
  }

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN);
  }

  setRefreshToken(token) {
    localStorage.setItem(REFRESH_TOKEN, token);
  }

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN);
  }

  removeTokens() {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(USER);
    localStorage.removeItem(USERID);
    localStorage.removeItem(USERNAME);
  }

  async getMe(accessToken, nombre) {
    try {
      const url = `${this.baseApi}/user/me`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Asegúrate de especificar el tipo de contenido
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          nombre: nombre,
        }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
